import React from "react";

/**
 * Persistent top-of-page banner shown to the customer while the agent has
 * remote control. The customer can revoke at any time (ESC or click here).
 * High z-index + fixed positioning so it stays visible regardless of where
 * the customer scrolls.
 */
export function RemoteControlBanner({ agentName, onRevoke }) {
  return (
    <div
      role="status"
      aria-live="polite"
      onClick={onRevoke}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2147483646,
        background: "linear-gradient(90deg, #f59e0b 0%, #ef4444 100%)",
        color: "white",
        padding: "8px 16px",
        fontSize: 13,
        fontWeight: 600,
        textAlign: "center",
        cursor: "pointer",
        boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
        animation: "khub-rc-pulse 2s ease-in-out infinite",
        userSelect: "none",
      }}
    >
      <span style={{ marginRight: 6 }}>🖱</span>
      {agentName ? <strong>{agentName}</strong> : "Your support agent"} is
      controlling your screen — press <kbd style={kbdStyle}>Esc</kbd> or click
      here to stop.
      <style>{`
        @keyframes khub-rc-pulse {
          0%, 100% { filter: brightness(1); }
          50%      { filter: brightness(1.15); }
        }
      `}</style>
    </div>
  );
}

const kbdStyle = {
  fontFamily: "monospace",
  background: "rgba(0,0,0,0.25)",
  padding: "1px 6px",
  borderRadius: 4,
  margin: "0 4px",
  fontSize: 11,
};
